import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { PrivacyToggle } from "@/components/site/PrivacyToggle";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Peopels" },
      { name: "description", content: "How Peopels collects, stores, uses and protects your personal data under UK GDPR." },
    ],
    links: [{ rel: "canonical", href: "/privacy" }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main id="main-content" className="mx-auto w-full max-w-3xl flex-1 px-4 py-16 sm:px-6 lg:px-8">
        <article className="prose prose-slate max-w-none">
          <h1 className="font-display text-4xl font-bold">Privacy Policy</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-GB")}</p>
          <p className="mt-6"><strong>Ashers Hub Ltd</strong>, a company registered in England and Wales under company number <strong>17204476</strong> and trading as Peopels ("we", "us"), is the controller of your personal data under the UK GDPR and Data Protection Act 2018.</p>
          <h2 className="mt-8 text-xl font-semibold">What we collect</h2>
          <p>Account details (name, email, phone), location (postcode), job and booking history, messages, reviews, payment metadata, device and usage data.</p>
          <h2 className="mt-8 text-xl font-semibold">Your rights</h2>
          <p>You can request a copy of your data, correction, or deletion at any time from your account settings, or by emailing privacy@peopels.com.</p>
          <h2 className="mt-8 text-xl font-semibold">Cookies</h2>
          <p>We use essential cookies to keep the site working. With your consent we also use analytics — see our Cookie Policy.</p>
          <h2 className="mt-8 text-xl font-semibold">Contact</h2>
          <p>privacy@peopels.com</p>
        </article>

        <section id="settings" className="mt-12 not-prose">
          <h2 className="font-display text-2xl font-bold">Privacy settings</h2>
          <p className="mt-1 text-sm text-muted-foreground">
            Control how Peopels uses cookies and analytics on this device. Turning analytics off does not affect bookings, payments or messaging.
          </p>
          <div className="mt-4">
            <PrivacyToggle />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
